// ========== Events Page ==========

if (document.querySelector(".events-page.all-events")) {
	const eventsSlider = new Swiper(".all-events .events-slider", {
		// allowTouchMove: false,
		loop: true,
		speed: 1600,
		slidesPerView: 2.3,
		centeredSlides: true,
		slidesPerGroup: 1,
		spaceBetween: -1,
		pagination: {
			el: ".events-slider .swiper-pagination",
			// type: "bullets",
			// clickable: true,
			type: "progressbar",
			clickable: true,
		},

		// scrollbar: {
		//   el: ".events-slider .swiper-scrollbar",
		//   // type: "bullets",
		//   // clickable: true,
		//   type: "progressbar",
		//   draggable: true,
		//   clickable: true,
		// },
		breakpoints: {
			0: {
				slidesPerView: 1.25,
				touchAngle: 45,
				touchRatio: 1,
			},
			769: {
				slidesPerView: 2.1,
			},
			993: {
				slidesPerView: 2.3,
				touchAngle: 180,
				touchRatio: 2,
			},
		},

		keyboard: {
			enabled: true,
			onlyInViewport: false,
			pageUpDown: true,
		},
		mousewheel: {
			invert: false,
			sensitivity: 1,
			eventsTarget: ".events-page",
		},
		initialSlide: 0,
		on: {
			init: function (swiper) {
				let slideElements = document.querySelectorAll(".events-slider .swiper-slide");
				slideElements.forEach((element) => {
					element.addEventListener("click", () => {
						if (element.classList.contains("swiper-slide-prev")) {
							swiper.slidePrev();
						}
						if (element.classList.contains("swiper-slide-next")) {
							swiper.slideNext();
						}
					});
				});
			},

			resize: function (swiper) {
				let slideElements = document.querySelectorAll(".events-slider .swiper-slide");
				slideElements.forEach((element) => {
					element.addEventListener("click", () => {
						if (element.classList.contains("swiper-slide-prev")) {
							swiper.slidePrev();
						}
						if (element.classList.contains("swiper-slide-next")) {
							swiper.slideNext();
						}
					});
				});

				var vw = $(window).width();
				var vh = $(window).height();
				if (vw > 769 && vw > vh) {
					eventsSlider.params.slidesPerView = 2.1;
				}
				if (vw > 769 && vw < vh) {
					eventsSlider.params.slidesPerView = 1.25;
				}
				eventsSlider.update();
			},
		},
	});

	const eventsTitleSlider = new Swiper(".events-slider-title", {
		direction: "vertical",
		loop: true,
		speed: 1600,
		centeredSlides: true,
		slidesPerView: 2.3,
		slidesPerGroup: 1,
		spaceBetween: 0,
		touchRatio: 2,
		touchAngle: 180,
		initialSlide: 0,
	});

	const eventsDateSlider = new Swiper(".events-slider-date", {
		direction: "vertical",
		loop: true,
		speed: 1600,
		slidesPerView: 2.3,
		centeredSlides: true,
		slidesPerGroup: 1,
		spaceBetween: 0,
		touchRatio: 2,
		touchAngle: 180,
		initialSlide: 0,
	});

	eventsSlider.controller.control = eventsDateSlider;
	eventsTitleSlider.controller.control = eventsDateSlider;
	eventsDateSlider.controller.control = eventsTitleSlider;
}
